var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    className: "hamburger-menu",
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C3.45 8 3 7.55 3 7C3 6.45 3.45 6 4          6H20C20.55 6 21 6.45 21 7C21 7.55 20.55 8 20 8H4ZM4          13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20          11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM4          18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20          16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/HamburgerMenu.da83b788cba9629d8edfc620b1152e2a.svg";
export { ForwardRef as ReactComponent };